import moment from 'moment'
import React, { useCallback } from 'react'
import { isEmpty } from '../../../../utils/stringUtils'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { Step5AresProps, Step5FormConditionsProps, Step5FormOptionsProps, Step5FormProps } from '../types'

const useStep5FormConditions = (
    form: Step5FormProps['form'],
    options: Step5FormOptionsProps,
    ares: Step5AresProps,
    activationObject?: ActivationObject
): Step5FormConditionsProps => {
    const { setValue } = form
    const startProtection = form.watch('startProtection')

    // endfree protection via startProtection data change
    React.useEffect(() => {
        if (startProtection && options.startProtectionDays) {
            const startProtectionMoment = moment(startProtection).startOf('day')
            const startDate = options.startProtectionDays.find((x) => x.startDate.isSame(startProtectionMoment))
            if (startDate) {
                setValue('endFreeProtection', startDate.endDate.toDate())
            }
        }
    }, [options.startProtectionDays, setValue, startProtection])

    // if empty startdate or already selected, but now not available, set to first available
    React.useEffect(() => {
        if (options.startProtectionDays) {
            const startProtectionMoment = startProtection && moment(startProtection).startOf('day')
            if (
                !startProtectionMoment ||
                options.startProtectionDays.findIndex((x) => x.startDate.isSame(startProtectionMoment) && x.isAvailable) === -1
            ) {
                const firstAvailableDay = options.startProtectionDays.find((x) => x.isAvailable)
                if (firstAvailableDay) setValue('startProtection', firstAvailableDay.startDate.toDate())
                else setValue('startProtection', undefined)
            }
        }
    }, [options.startProtectionDays, setValue, startProtection])

    // checking day availability in calendar
    const isDayUnavailable = useCallback(
        (date: Date) => {
            const dateMoment = moment(date).startOf('day')
            return (
                options.startProtectionDays === undefined ||
                options.startProtectionDays.findIndex((x) => x.startDate.isSame(dateMoment) && x.isAvailable) === -1
            )
        },
        [options.startProtectionDays]
    )

    // set form.ico from searched ICO
    React.useEffect(() => {
        setValue('ico', ares.icoSearch)
    }, [ares.icoSearch, setValue])

    // const invoiceAddressZIP = form.watch('invoiceAddressZIP')
    // const invoiceAddressCity = form.watch('invoiceAddressCity')
    // const invoiceAddressName = form.watch('invoiceAddressName')
    // const invoiceAddressStreet = form.watch('invoiceAddressStreet')
    // const invoiceAddressCodeNumber = form.watch('invoiceAddressCodeNumber')
    // const invoiceAddressGuidanceNumber = form.watch('invoiceAddressGuidanceNumber')
    // const vat = form.watch('vat')
    // set invoicing data from ares
    React.useEffect(() => {
        if (ares.companyData && ares.companyData.ic !== activationObject?.ico) {
            setValue('ico', ares.companyData.ic)
            // if (isEmpty(invoiceAddressZIP)) setValue('invoiceAddressZIP', ares.companyData.zip)
            // if (isEmpty(invoiceAddressName)) setValue('invoiceAddressName', ares.companyData.name)
            // if (isEmpty(invoiceAddressCity)) setValue('invoiceAddressCity', ares.companyData.city)
            // if (isEmpty(invoiceAddressStreet)) setValue('invoiceAddressStreet', ares.companyData.street)
            // if (isEmpty(invoiceAddressCodeNumber)) setValue('invoiceAddressCodeNumber', ares.companyData.codeNumber)
            // if (isEmpty(invoiceAddressGuidanceNumber)) setValue('invoiceAddressGuidanceNumber', ares.companyData.guidanceNumber)
            // if (isEmpty(vat)) setValue('vat', ares.companyData.vat)
            setValue('invoiceAddressZIP', ares.companyData.zip)
            setValue('invoiceAddressName', ares.companyData.name)
            setValue('invoiceAddressCity', ares.companyData.city)
            setValue('invoiceAddressStreet', ares.companyData.street)
            setValue('invoiceAddressCodeNumber', ares.companyData.codeNumber)
            setValue('invoiceAddressGuidanceNumber', ares.companyData.guidanceNumber)
            setValue('vat', ares.companyData.vat)
        }
    }, [activationObject?.ico, ares.companyData, setValue])

    // set first sendDocumentationEmail
    const emailSendingDocumentation = form.watch('emailSendingDocumentation')
    React.useEffect(() => {
        if (
            options.sendDocumentationEmails[0] &&
            (isEmpty(emailSendingDocumentation) ||
                options.sendDocumentationEmails.findIndex((option) => option.value === emailSendingDocumentation) === -1)
        )
            setValue('emailSendingDocumentation', options.sendDocumentationEmails[0].value)
    }, [emailSendingDocumentation, options.sendDocumentationEmails, setValue])

    return {
        isDayUnavailable,
        personType: activationObject?.personType,
    }
}

export default useStep5FormConditions
